require('sass/blocks/headline/_headline.scss');

const AdditionalIcon = require('assets/icons/headline/additional.svg');
const DocumentsIcon = require('assets/icons/headline/documentos.svg');
const FirmaIcon = require('assets/icons/headline/firma.svg');
const ClientIcon = require('assets/icons/headline/hazte_cliente.svg');
const IdentificationIcon = require('assets/icons/headline/identificacion.svg');
const FiocIcon = require('assets/icons/headline/fioc.svg');
const HolderIcon = require('assets/icons/headline/intervinietes.svg');
const StandByFinal = require('assets/icons/headline/grey_additional.svg');
const HoldersIcon = require('assets/icons/headline/cotitulares_01.svg');
const Tarjeta = require('assets/icons/headline/tarjeta.svg');
const StandByHC = require('assets/icons/headline/icon-sobre.svg');
const DepositsIcon = require('assets/icons/headline/deposits.svg');
const LockIcon = require('assets/icons/headline/lock.svg');
const Id = require('assets/icons/icon-id.png');
const Bills = require('assets/icons/icon-bills.png');
const TransferIcon = require('assets/icons/identity/icon-transfer.svg');
const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');

const Headline = ({ children, className, icon, withIcon }) => {
    const availableIcons = {
        adicional: AdditionalIcon,
        cliente: ClientIcon,
        documentos: DocumentsIcon,
        fioc: FiocIcon,
        firma: FirmaIcon,
        holder: HolderIcon,
        holders: HoldersIcon,
        identificacion: IdentificationIcon,
        standByFinal: StandByFinal,
        tarjeta: Tarjeta,
        transfer: TransferIcon,
        standByHC: StandByHC,
        id: Id,
        bills: Bills,
        ine: Bills,
        deposits: DepositsIcon,
        lock: LockIcon,
    };
    const qtyChildren = React.Children.count(children);

    const getIcon = withIcon ? (
        <div className="prospects-headline-icon">
            <img src={availableIcons[icon]} alt="" />
        </div>
    ) : null;

    return (
        <div className={`prospects-headline ${className}`}>
            {getIcon}
            <div
                className={classNames('prospects-headline-content', {
                    'prospects-headline-content--centered': qtyChildren <= 1,
                })}
            >
                {children}
            </div>
        </div>
    );
};

Headline.propTypes = {
    children: PropTypes.any,
    className: PropTypes.string,
    icon: PropTypes.oneOf([
        'adicional',
        'cliente',
        'documentos',
        'fioc',
        'firma',
        'holder',
        'holders',
        'identificacion',
        'standByFinal',
        'tarjeta',
        'standByHC',
        'bills',
        'ine',
    ]),
    withIcon: PropTypes.bool,
};

Headline.defaultProps = {
    withIcon: true,
};

module.exports.constructor = Headline;
module.exports = Headline;
